import {
  getFromStorage,
  REACT_APP_AWSAccessKeyId,
  REACT_APP_AWSSecretKey,
  REACT_APP_REGION,
  REACT_APP_Bucket,
} from "./Constant";

import AWS from "aws-sdk";
const s3 = new AWS.S3({
  accessKeyId: REACT_APP_AWSAccessKeyId,
  secretAccessKey: REACT_APP_AWSSecretKey,
  region: REACT_APP_REGION,
});

export const uploadAWS = async (fileObj, directory, method) => {
  console.log(fileObj, "datamethod");
  try {
    const date = new Date();
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const miliSeconds = date.getUTCMilliseconds() + 1;

    // let hotelier_id = getFromStorage("id");
    const name = fileObj.name.split(".");

    console.log(month,year, "monthyearimageupload")
    // console.log(`${directory}/${year}/${month}/${month}${year}${miliSeconds}_${Math.floor(Date.now() )}_${fileObj.name.replace(/\s+/g, "-")}`, "monthyearimageupload")

    const params = {
      Bucket: REACT_APP_Bucket,
      Key: `${directory}/${year}/${month}/${month}${year}${miliSeconds}_${Math.floor(Date.now() )}_${fileObj.name.replace(/\s+/g, "-")}`, //  ${name[name.length - 1]}`,
      ContentType: name[name.length - 1],
      Body: fileObj,
    };

    console.log(params , "dataparam ashi");
    await s3.upload(params, function (err, data) {
      if (err) {
      } else {
        const returnData = {
          signedRequest: data,
          url: data.Location,
        };
        // Send it all back
        //   res.json({success:true, data:{returnData}});
console.log(data.Location,"url345");
        method(data.Location);
      }
    });
  } catch (e) {
    console.log("erreoby aws");
    // message.error(e.message)
  }
};

export const uploadFileWithNameAWS = async (
  fileObj,
  directory,
  filename,
  method
) => {
  try {
    const date = new Date();
    const year = date.getFullYear();
    const month = date.getMonth() + 1;

    // let hotelier_id = getFromStorage("id");
    const name = fileObj.name.split(".");

    const params = {
      Bucket: REACT_APP_Bucket,
      Key: `${directory}/${filename}`, // ${month}${year}_${Math.floor(Date.now() / 1000)}.${name[name.length-1]} ,
      ContentType: name[name.length - 1],
      Body: fileObj,
    };

    await s3.upload(params, function (err, data) {
      if (err) {
      } else {
        const returnData = {
          signedRequest: data,
          url: data.Location,
        };
        // Send it all back
        //   res.json({success:true, data:{returnData}});

        method(data.Location);
      }
    });
  } catch (e) {
    // message.error(e.message)
  }
};
